module.exports = __webpack_public_path__ + "static/media/vivo-logo.50055752.svg";